import React from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getQueryStringOfUrl } from '../util/helpers';

export const useNavigation = () => {
  const navigate = useNavigate();
  let params = useParams();

  const { pathname } = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();
  const gotoPage = (path: string) => {
    if (searchParams.size > 0) {
      const queryString = {
        ...getQueryStringOfUrl(true),
        ...getQueryStringOfUrl(true, path),
      };
      const newPath = path.split('?')[0] || '';
      navigate(`${newPath}?${new URLSearchParams(queryString).toString()}`);
    } else {
      navigate(`${path}`);
    }
  };
  const currentPath = () => {
    return pathname;
  };
  const gotoBack = () => {
    navigate(-1);
  };

  return {
    gotoPage,
    gotoBack,
    currentPath: currentPath(),
    params,
  };
};
export default useNavigation;
